(ns minorodata.components.pipeline-editor.transform
  (:require
   ["@xyflow/react" :refer [ReactFlowProvider]]
   ["allotment" :refer [Allotment]]
   ["react" :as react]
   [applied-science.js-interop :as jsi]
   [goog.functions :refer [debounce]]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.components.pipeline-editor.dag :refer [subdag]]
   [minorodata.components.pipeline-editor.details.core :refer [details]]
   [re-posh.core :as re-posh]
   [ui.drawer]))

(defn fetch-transform-dag [dag-id filters]
  (dispatch [:pipeline-editor.events/set-dag-filter {:params (merge {:id dag-id} filters)}]))

(defn dag [{:keys [dag-data transform]}]
  (let [{:keys [master-id]} transform]
    [:div {:class "h-full"}
     [:f> subdag {:id            master-id
                  :dag-data      dag-data
                  :apply-filters #(fetch-transform-dag (:id dag-data) %)}]]))

(defn transform-page' [{:keys [master-id transform selected sandbox? dag-data panel-state]}]
  (let [panel-ref     (react/useRef nil)
        initial-sizes (react/useMemo (fn [] (js->clj (:sizes panel-state))) #js [])]
    (react/useEffect
     (fn []
       #_(jsi/call-in panel-ref [:current :resize] (clj->js (cond-> (:sizes panel-state)
                                                            (= 3 (count (:sizes panel-state)))
                                                            next)))
       js/undefined)
     #js [(:sizes panel-state)])

    [:> Allotment {:ref      panel-ref
                   :vertical true
                   :default-sizes (cond-> initial-sizes
                                    (= 3 (count initial-sizes))
                                    next)
                   :on-change     (debounce #(let [sizes (js->clj %)
                                                   sizes (cond-> sizes
                                                           (= 3 (count sizes))
                                                           next)]
                                               (when (not= sizes (:sizes panel-state))
                                                 (dispatch [:pipeline-editor.events/set-panel-sizes sizes])))
                                            200)}
     [:> Allotment.Pane {:min-size       150
                         :preferred-size "50%"
                         :snap           true
                         :class "relative"}
      [dag {:dag-data  dag-data
            :transform transform}]]
     [:> Allotment.Pane {:min-size       200
                         :preferred-size "50%"
                         :snap           true}
      [details {:selected selected}]]]))

(defn transform-page [{:keys [master-id group-id] :as props}]
  (let [panel-state @(re-posh/subscribe [:pipeline-editor.subs/panel])
        sandbox?    @(re-posh/subscribe [:sandbox.subs/enabled?])
        transform   @(re-posh/subscribe [:pipeline-editor.subs/full-transform master-id])
        dag-data    @(re-posh/subscribe [:pipeline-editor.subs/dag master-id :transform sandbox?])
        query       @(re-posh/subscribe [:app-route/prop :app-route/query])]
    [:> ReactFlowProvider
     [:f> transform-page' (assoc props
                                 :panel-state panel-state
                                 :transform   transform
                                 :dag-data           dag-data
                                 :sandbox?           sandbox?
                                 :selected     (if (:tab-preview-type query)
                                                 {:type (:tab-preview-type query)
                                                  :id   (:tab-preview-id query)
                                                  :group-id (:tab-preview-group-id query)
                                                  :preview true}
                                                 {:type "transform"
                                                  :id master-id
                                                  :group-id group-id}))]]))
